<section class="mx-3">
    <div class="d-flex justify-content-between align-items-center mx-4 py-3">
        <div class="page_header">
            <h3 translate class="m-0 page_header_title">Add Streams</h3>
        </div>
    </div>
    <ng-template *ngIf="errorMessage">
        <small class="text_color_red">{{ errorMessage }}</small>
      </ng-template>
    <div class="container">
        <form (ngSubmit)="onSubmit()" [formGroup]="form">
            <div class="row">
                <div *ngFor="let question of questions" class="col-sm-6 mb-3">
                    <app-question [question]="question" [form]="form"></app-question>
                </div>
            </div>
            <div class="d-flex justify-content-center my-4">
                <div class="form-row">
                    <button translate mat-stroked-button color="primary" (click)="closeDialog()" class="px-5 cancel_button">Cancel</button>
                </div>
            <div class="ms-3">
                <button translate mat-raised-button color="primary" class="px-5 submit_button" type="submit" [disabled]="!form.valid">Submit</button>
            </div>
        </div>
        </form>
        <!-- <div *ngIf="payLoad" class="form-row">
        <strong>Saved the following values</strong><br>{{payLoad}}
      </div> -->
    </div>
</section>